export function onClientEntry() {
    const doc = document.documentElement;

    doc.classList.remove("no-js");
    doc.classList.add("js");
}